import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty-widget',
  templateUrl: './empty-widget.component.html',
  styleUrls: ['./empty-widget.component.scss'],
  standalone: false
})
export class EmptyWidgetComponent {
  @Input() title: string = '';
}
